import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import MCAReportPageUI from './MCAReportPageUI.js'

class MCAReportPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      mcaReport: null,
      balanceSheetList: [],
      profitAndLossList: [],
      ratioAnalysisList: [],
      shareholdingPatternList: [],
      chargeValueCalculation: null,
      editable: false,
      mcaParameterUpdateBSMode: false,
      mcaParameterUpdatePLMode: false,
      yearList: []
    }
  }

  render() {
    return (
      <MCAReportPageUI
        context={this.props.context}
        account={this.state.account}
        mcaReport={this.state.mcaReport}
        balanceSheetList={this.state.balanceSheetList}
        profitAndLossList={this.state.profitAndLossList}
        ratioAnalysisList={this.state.ratioAnalysisList}
        shareholdingPatternList={this.state.shareholdingPatternList}
        chargeValueCalculation={this.state.chargeValueCalculation}
        onRefreshClick={this.onRefreshClick}
        toggleEditable={() => { this.setState({ editable: !this.state.editable }) }}
        editable={this.state.editable}
        //Balance Sheet
        mcaParameterUpdateBSMode={this.state.mcaParameterUpdateBSMode}
        onMcaParameterUpdateBSClick={this.onMcaParameterUpdateBSClick}
        onMcaParameterUpdateBSCancel={() => { this.setState({ mcaParameterUpdateBSMode: false }) }}

        // Profit and Loss
        mcaParameterUpdatePLMode={this.state.mcaParameterUpdatePLMode}
        onMcaParameterUpdatePLClick={this.onMcaParameterUpdatePLClick}
        onMcaParameterUpdatePLCancel={() => { this.setState({ mcaParameterUpdatePLMode: false }) }}

        selectedParameterName={this.state.selectedParameterName}
        yearList={this.state.yearList}
      />
    )
  }

  onMcaParameterUpdateBSClick = (event) => {
    let selectedParameterName = event.currentTarget.getAttribute('data-name')
    this.setState({ mcaParameterUpdateBSMode: true, selectedParameterName: selectedParameterName })
  }

  onMcaParameterUpdatePLClick = (event) => {
    let selectedParameterName = event.currentTarget.getAttribute('data-name')
    this.setState({ mcaParameterUpdatePLMode: true, selectedParameterName: selectedParameterName })
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccounts(context)
    this.getMCAReport(context)
    this.getYears(context)
  }

  getMCAReport(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/mca`,
      cacheKey: CacheKeys.MCAReport(this.props.match.params.accountId),
      callback: this.getMCAReportCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getMCAReportCallback = (response) => {
    this.setState({
      mcaReport: response.mcaReport,
      balanceSheetList: response.balanceSheetList,
      profitAndLossList: response.profitAndLossList,
      ratioAnalysisList: response.ratioAnalysisList,
      shareholdingPatternList: response.shareholdingPatternList,
      chargeValueCalculation: response.chargeValueCalculation
    })
    console.log(response.chargeValueCalculation);
  }

  getAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Accounts(this.props.match.params.accountId),
      callback: this.getAccountsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountsCallback = (response) => {
    this.setState({ account: response.account })
  }

  getYears(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/years`,
      cacheKey: CacheKeys.Years(),
      callback: this.getYearsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getYearsCallback = (response) => {
    let yearList = response.financialYearList.map((years) => {
      return { value: years, label: years }
    })
    this.setState({ yearList: yearList })
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.MCAReport(this.props.match.params.accountId))
    this.setState({ mcaReport: null, profitAndLossList: null },
      this.getMCAReport(this.props.context)
    )
  }
}

export default withRouter(MCAReportPageSF)
